import Link from "next/link";
import React, { useState } from "react";
import striptags from "striptags";

const FaqSection = ({
	serviceDetail,
	showAllFaqs,
	activeindex,
	setShowAllFaqs,
}) => {
	const [activeItem, setActiveItem] = useState(0);
	const toggleAccordion = (itemIndex) => {
		if (activeItem === itemIndex) {
			setActiveItem(null); // Close the currently open accordion
		} else {
			setActiveItem(itemIndex); // Open the clicked accordion
		}
	};
	return (
		<section className="faq-section" style={{
			paddingTop: 0,
			paddingBottom: 0,
		}}>
			<div className="faq-inner">
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="section-heading">
								<span
									itemProp="heading"
									dangerouslySetInnerHTML={{
										__html: "FAQs",
									}}
								></span>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-lg-12">
							<div className="faq-accordion">
								<div
									className="accordion accordion-flush"
									id="accordionExample"
								>
									{serviceDetail?.value?.list?.map((val, index) => {
										if (!showAllFaqs && index >= 2) return null;
										return (
											<div key={`${index}_h`} className="accordion-item">
												<h3 className="accordion-header" id={`heading${index}`}>
													<button
														className={`accordion-button ${activeItem === index ? "" : "collapsed"
															}`}
														type="button"
														onClick={() => toggleAccordion(index)}
														data-bs-toggle="collapse"
														data-bs-target="#collapseOne"
														aria-expanded={
															activeItem === index ? "true" : "false"
														}
														aria-controls="collapseOne"
													>
														{striptags(val?.value?.title)}
													</button>
												</h3>
												<div
													id={`collapse${index}`}
													className={`accordion-collapse collapse ${activeItem === index ? "show" : ""
														}`}
													aria-labelledby={`heading${index}`}
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<p
															dangerouslySetInnerHTML={{
																__html: val?.value?.description,
															}}
														></p>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
						<div className="col-lg-12">
							<div className="see-all-faq">
								{!showAllFaqs && (
									<Link
										href="#!"
										itemProp="link"
										className="link-font-lg"
										onClick={setShowAllFaqs}
									>
										See All
									</Link>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default FaqSection;
